export const isFormDisabled = (emailPreferences, currentPreference) => emailPreferences
  && emailPreferences.data
  && emailPreferences.data.optionEmailPreferences === currentPreference;
